import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepConnector from '@material-ui/core/StepConnector'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22
  },
  active: {
    '& $line': {
      backgroundColor: '#3f51b5'
    }
  },
  completed: {
    '& $line': {
      backgroundColor: '#3f51b5'
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1
  }
})(StepConnector)

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#707070',
    zIndex: 1,
    color: '#ffffff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  active: {
    backgroundColor: '#3f51b5',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundColor: '#3f51b5'
  }
})

function ColorlibStepIcon (props) {
  const classes = useColorlibStepIconStyles()
  const { active, completed } = props

  const icons = {
    1: <LocalShippingIcon />,
    2: <LocalShippingIcon />,
    3: <LocalShippingIcon />,
    4: <LocalShippingIcon />,
    5: <LocalShippingIcon />
  }

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {completed ? <CheckCircleIcon /> : icons[String(props.icon)]}
    </div>
  )
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node
}

function getSteps () {
  return ['Playa municipal', 'Calado', 'Playa calado', 'Descarga']
}

export default function CustomizedSteppers (props) {
  const steps = getSteps()

  const { instancia } = props

  return (
    <div>
      <Stepper alternativeLabel activeStep={instancia} connector={<ColorlibConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  )
}
